// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import OrderQuery from '../OrderQuery.vue'
import OrderView from '../OrderView.vue'

const routes = [
  {
    path: '/',
    name: 'OrderQuery',
    component: OrderQuery,
	props: (route) => ({
		shopId: route.query.shopId || null
	})
  },
  {
    path: '/order-view',
      name: 'OrderView',
      component: OrderView,
		props: (route) => ({
			key: route.query.key,
			shopId: route.query.shopId || null
		})
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  console.log('当前路由配置:', to.matched[0]?.path); // 打印匹配的路由路径
  next();
})

export default router